'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

/**
 * 日历组件
 */
var Calendar = React.createClass({
  render: function () {
    var backgroundStyle = {
      width: '100%',
      height: '100%',
      borderStyle: 'none'
    };

    return (<img style={backgroundStyle}
                 src={assetsHelper.getComponentAsset('Calendar')}
    />);
  }
});

module.exports = Calendar;



// WEBPACK FOOTER //
// ./src/views/Components/Calendar.jsx